import { Component, input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';

@Component({
  selector: 'vb-lxp-tooltip',
  standalone: true,
  imports: [CommonModule, DecimalPipe, TimespanMsPipe, TimespanShortPipe],
  templateUrl: './vb-lxp-tooltip.component.html',
  styleUrl: './vb-lxp-tooltip.component.css',
  host: { class: 'vb-lxp-tooltip-host' },
})
export class VbLxpTooltipComponent {
  public team = input<any>(null);
}
